import KyError from 'components/Errors/KyError';
import Loading from 'components/Loading';
import FullWidthTemplate from 'components/Templates/FullWidth';
import {useGet} from 'helpers/KyHooks';
import GitHubTable from 'pages/public/github/list/Table';

export default function GitHubListPage() {
  const {response, error} = useGet('api/v1/github/list');

  let body = <Loading />;
  if (response) {
    body = <GitHubTable data={response.data.gitHubMetaData} />;
  } else if (error) {
    body = <KyError kyError={error} />;
  }

  return (
    <FullWidthTemplate title="GitHub List Page">
      {body}
    </FullWidthTemplate>
  );
}
